import React, { useContext } from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { COLORS } from "@app/constants";
import { View } from "@/styles/reactnative";
import { data, getIntroOfPage } from "../chartData";
import { ThemeContext } from "@/theme/ThemeProvider";

const CustomTooltip = ({ active, payload, label }: any) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip" style={{ color: textw }}>
        <p className="label">{`${label} : ${payload[0].value}`}</p>
        <p className="intro" style={{ color: textw }}>
          {getIntroOfPage(label)}
        </p>
        <p className="desc" style={{ color: textw }}>
          Anything you want can be displayed here.
        </p>
      </div>
    );
  }
  return null;
};
const CryptoMarketGraph = () => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  return (
    <View style={{ width: "100%", height: "70%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          width={730}
          height={250}
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" tick={{ fill: textw, fontSize: 13 }} />
          <YAxis tick={{ fill: textw, fontSize: 13 }} />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip
            cursor={{
              stroke: COLORS.secondary,
              strokeWidth: 2,
              strokeDasharray: 2,
            }}
            separator={" "}
            itemStyle={{}}
            wrapperStyle={{}}
            contentStyle={{}}
            labelStyle={{}}
            label={"Hello world"}
            content={<CustomTooltip />}
          />
          <Area
            type="monotone"
            dataKey="uv"
            stroke="#8884d8"
            fillOpacity={1}
            fill="url(#colorUv)"
          />
          <Area
            type="monotone"
            dataKey="pv"
            stroke="#82ca9d"
            fillOpacity={1}
            fill="url(#colorPv)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </View>
  );
};

export default React.memo(CryptoMarketGraph);
// const res = Array(25).fill(0).map(Math.random);
